<template>
    <div>
        <div @click="open = !open">
            <button
                type="button"
                class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:ring"
                id="user-menu"
                aria-label="User menu"
                aria-haspopup="true"
            >
                <img class="h-8 w-8 rounded-full" :src="avatar" alt="avatar" />
            </button>
        </div>

        <!-- to close when clicked on space around it-->
        <button
            class="fixed inset-0 h-full w-full cursor-default focus:outline-none"
            v-if="open"
            @click="open = false"
            tabindex="-1"
        ></button>

        <!--dropdown menu-->
        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transition ease-out duration-100"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg" v-if="open">
                <div
                    class="py-1 rounded-md bg-white ring-1 ring-black ring-opacity-5"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu"
                >
                    <slot name="content"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    props: {
        avatar: {
            type: String,
            default: '',
        },
    },
    methods: {
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
